import { Component } from '@angular/core';
import { BaseComponent } from '../../../../models/base/base-component';
import { DashboardViewModel } from './dashboard-view-model';
import { TypeService } from '../../../../services/type-service';
import {
  apisGloballyScopedToLoginContext,
  domainModelsGloballyScopedToLoginContext,
  repositoriesGloballyScopedToLoginContext,
  servicesGloballyScopedToLoginContext,
  viewModelsGloballyScopedToLoginContext
} from '../../../../di/logged-in-scope';
import { SmartFiltersDomainModel } from '../../../../domainModels/smart-filters-domain-model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UserDomainModel } from '../../../../domainModels/user-domain-model';
import { SyncDomainModel } from '../../../../domainModels/sync-domain-model';
import { DisplayAttributesDomainModel } from '../../../../domainModels/display-attributes-domain-model';
import { TemplateDomainModel } from '../../../../domainModels/template-domain-model';
import { ProductDomainModel } from '../../../../domainModels/product-domain-model';
import { ProductTagDomainModel } from '../../../../domainModels/product-tag-domain-model';
import { FileSystemService } from '../../../../services/file-system.service';
import { MediaManagerDomainModel } from '../../../../domainModels/media-manager/media-manager-domain-model';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  providers: [
    ...apisGloballyScopedToLoginContext,
    ...repositoriesGloballyScopedToLoginContext,
    ...domainModelsGloballyScopedToLoginContext,
    ...viewModelsGloballyScopedToLoginContext,
    ...servicesGloballyScopedToLoginContext,
    DashboardViewModel
  ],
  standalone: false
})
export class DashboardComponent extends BaseComponent {
  /**
   * The order of the injected objects in the constructor matters. It is the order in which they are initialized.
   *
   * Do not remove unused objects from this constructor. They are used to initialize the objects when the user logs in.
   * Do not remove: typeService, smartFiltersDomainModel, syncDomainModel.
   */
  constructor(
    private typeService: TypeService,
    private fileSystemService: FileSystemService,
    private productDomainModel: ProductDomainModel, // initialize on login
    private smartFiltersDomainModel: SmartFiltersDomainModel, // initialize on login
    private syncDomainModel: SyncDomainModel, // uses web sockets, so init on login
    private displayAttributeDomainModel: DisplayAttributesDomainModel, // uses web sockets, so init on login
    private templateDomainModel: TemplateDomainModel, // initialize on login
    private productTagDomainModel: ProductTagDomainModel, // uses web sockets, so initialize on login
    private mediaManagerDomainModel: MediaManagerDomainModel, // initialize on login
    private userDomainModel: UserDomainModel,
    private ngbModal: NgbModal,
    public viewModel: DashboardViewModel
  ) {
    super();
  }

  override async setupViews() {
    await this.fileSystemService.setupTabLeadership();
  }

  /**
   * Dismiss all open models when logged in context dies.
   */
  override destroy() {
    super.destroy();
    this.ngbModal.hasOpenModals() && this.ngbModal.dismissAll();
  }
}
